'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const EndPointTriangleIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="EndPointTriangleIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="End-Point-Triangle-Arrow-1--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>End Point Triangle Arrow 1 Streamline Icon: https://streamlinehq.com</desc>
        <path
          stroke={sx?.color || '#3D517B'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M1 12h14"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#3D517B'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m15 7 8 5 -8 5V7Z"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

EndPointTriangleIcon.propTypes = {
  sx: PropTypes.object
}
